/* eslint-disable no-console */

import { RtDebugAngularType } from './rt-debug-recognizer';

enum Color {
  Primary = '#1999e3',
}

export class RtLogger {
  public static emojis = {
    log: '🏷',
    measure: '⏲️',
    ngComponent: '⚙️',
    ngDirective: '🔧',
    ngOnInit: '❤️',
    ngDoCheck: '🌀',
    ngAfterContentInit: '💓',
    ngAfterContentChecked: '💓',
    ngAfterViewInit: '️💓',
    ngAfterViewChecked: '💓',
    ngOnChanges: '🌀',
    ngOnDestroy: '💔',
    rtStateWillChange: '🌀',
    rtStateWillInit: '❤️',
  };

  public static headline(string: string): void {
    console.log(`%c${string}`, `color: ${Color.Primary}`);
  }

  public static legend(): void {
    const emojiLegendStr = Object.keys(RtLogger.emojis).reduce(
      (prev, curr: keyof typeof RtLogger.emojis) => {
        const display = `${RtLogger.emojis[curr]} :: ${curr}`;

        if (prev) {
          return `${prev}\n${display}`;
        } else {
          return display;
        }
      },
      '',
    );

    console.log(
      `%cLegend%c\n${emojiLegendStr}`,
      `color: ${Color.Primary}; font-size:1.2rem`,
      `font-size:.8rem`,
    );
  }

  public static measure(signature: string | string[], time: number, async: boolean): void {
    const emoji = RtLogger.emojis['measure'];

    if (Array.isArray(signature)) {
      const methodName = signature.slice(signature.length - 1).pop();
      const className = signature.slice(0, signature.length - 1).join('.');

      console.log(
        `${emoji} ${className}.%c${methodName}%c :: ${time}ms`,
        `color: ${Color.Primary}`,
        '',
      );
    } else {
      console.log(`${emoji} %c${signature}%c :: ${time}ms`, `color: ${Color.Primary}`, '');
    }
  }

  // eslint-disable-next-line max-lines-per-function
  public static lifecycle(
    methodName: keyof typeof RtLogger.emojis,
    className: string,
    ngType: RtDebugAngularType,
    args: any[],
  ): void {
    const kindEmoji =
      RtLogger.emojis[ngType === RtDebugAngularType.Component ? 'ngComponent' : 'ngDirective'];

    console.log(
      `${kindEmoji} ${RtLogger.emojis[methodName]} ${className}.%c${methodName}%c`,
      `color: ${Color.Primary}`,
      ``,
    );

    switch (methodName) {
      case 'ngOnChanges': {
        console.table(...args);
        break;
      }

      case 'rtStateWillInit': {
        const [state] = args;
        console.table([state]);
        break;
      }

      case 'rtStateWillChange':
        const [prevState, nextState] = args;
        const stateDiffKeys = Object.keys({ ...prevState, ...nextState }).filter(
          key => nextState[key] !== prevState[key],
        );
        console.table([
          stateDiffKeys.reduce((acc, key) => ({ ...acc, [key]: prevState[key] }), {}),
          stateDiffKeys.reduce((acc, key) => ({ ...acc, [key]: nextState[key] }), {}),
        ]);
        break;

      default:
        break;
    }
  }

  public static warn(message: string): void {
    console.warn(message);
  }
}
